export class CommitmentReason {
    commitmentReasonID: number;
    name: string;
}                         